import Image, { StaticImageData } from 'next/image'
import { Button } from 'components/Button'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import {
  RecipesRoot,
  RecipesContainer,
  Title,
  Section,
  Proteins,
  ProteinTitle,
  BottomImageWrapper,
  ButtonWrapper,
  ProteinSelectionV2,
  ProteinImageContainer,
  ProteinImagesRow,
} from './Recipes.styles'
import { Stack } from 'components/Stack'
import Link from 'next/link'
import { TranslationKeys } from 'locales/translationKeys'
import beef from '../../../../../public/assets/icons/brand-refresh/beef.webp'
import lamb from '../../../../../public/assets/icons/brand-refresh/lamb.webp'
import turkey from '../../../../../public/assets/icons/brand-refresh/turkey.webp'
import chicken from '../../../../../public/assets/icons/brand-refresh/chicken.webp'
import duck from '../../../../../public/assets/icons/brand-refresh/duck.webp'
import freezeDriedAndFrozen from '../../../../../public/assets/product-v2/all-products-hero.webp'

export const Recipes = () => {
  const { t } = useTranslation()

  type proteinIconV2 = {
    imageSrc: StaticImageData
    imageAlt: TranslationKeys
    link: string
  }

  const frozen: proteinIconV2[] = [
    {
      imageSrc: beef,
      imageAlt: 'home:proteins.beef',
      link: '/recipes/beef',
    },
    {
      imageSrc: turkey,
      imageAlt: 'home:proteins.turkey',
      link: '/recipes/turkey',
    },
    {
      imageSrc: chicken,
      imageAlt: 'home:proteins.chicken',
      link: '/recipes/chicken',
    },
    {
      imageSrc: duck,
      imageAlt: 'home:proteins.duck',
      link: '/recipes/duck',
    },
    {
      imageSrc: lamb,
      imageAlt: 'home:proteins.lamb',
      link: '/recipes/lamb',
    },
  ]

  const freezeDried: proteinIconV2[] = [
    {
      imageSrc: beef,
      imageAlt: 'home:proteins.beef',
      link: '/recipes/freeze-dried-raw-beef',
    },
    {
      imageSrc: chicken,
      imageAlt: 'home:proteins.chicken',
      link: '/recipes/freeze-dried-raw-chicken',
    },
  ]

  return (
    <RecipesRoot>
      <RecipesContainer>
        <Stack justifyContent="center">
          <Title font="display" size={{ '@initial': 'h3', '@bp2': 'h1' }}>
            {t('home:properties.title')}
          </Title>
        </Stack>
        <Section reverse>
          <Proteins>
            <ProteinTitle size="body">{t('home:proteins.title')}</ProteinTitle>

            <Stack direction="column" gap="3">
              <ProteinSelectionV2>
                <Text font="label" transform="uppercase" size="h5">
                  {t('home:proteins.frozen')}
                </Text>
                <ProteinImagesRow>
                  {frozen.map((protein, index) => (
                    <Link passHref key={index} href={protein.link}>
                      <ProteinImageContainer>
                        <Image src={protein.imageSrc} alt={t(protein.imageAlt)} />
                      </ProteinImageContainer>
                    </Link>
                  ))}
                </ProteinImagesRow>
              </ProteinSelectionV2>
              <ProteinSelectionV2>
                <Text font="label" transform="uppercase" size="h5">
                  {t('home:proteins.freeze-dried')}
                </Text>
                <ProteinImagesRow>
                  {freezeDried.map((protein, index) => (
                    <Link passHref key={index} href={protein.link}>
                      <ProteinImageContainer>
                        <Image src={protein.imageSrc} alt={t(protein.imageAlt)} />
                      </ProteinImageContainer>
                    </Link>
                  ))}
                </ProteinImagesRow>
              </ProteinSelectionV2>
            </Stack>
          </Proteins>
          <BottomImageWrapper>
            <Image
              objectFit="cover"
              width={634}
              height={438}
              src={freezeDriedAndFrozen}
              alt={t('home:properties.image-v2')}
            />
          </BottomImageWrapper>
        </Section>
        <ButtonWrapper>
          <Link href="/meal-plan" passHref>
            <Button as="a" className="cta">
              {t('home:CTA')}
            </Button>
          </Link>
        </ButtonWrapper>
      </RecipesContainer>
    </RecipesRoot>
  )
}

Recipes.displayName = 'Recipes'
